// Import React.
import React from "react";



// Export the FAQ section.
export const FaqSection = ({
    faqs = [],
}) => {

    // Return nothing when no FAQs have been supplied.
    if (faqs.length === 0) {

        // Prevent an empty section being displayed.
        return null;

    }



    // Render the FAQ section.
    return (

        // Add the FAQ identifier used by the navigation button.
        <section
            className="landing-faq"
            id="faq"
            aria-labelledby="landing-faq-title"
        >

            {/* Constrain the FAQ content width. */}
            <div className="landing-faq__inner">

                {/* Render the FAQ heading. */}
                <h2
                    className="landing-faq__title"
                    id="landing-faq-title"
                >
                    Frequently Asked Questions
                </h2>

                {/* Render the FAQ items. */}
                <div className="landing-faq__items">

                    {/* Loop through each supplied FAQ. */}
                    {faqs.map((faq, faqIndex) => (

                        // Render an expandable FAQ.
                        <details
                            className="landing-faq__item"
                            key={faq?.id ?? faqIndex}
                        >

                            {/* Render the clickable question. */}
                            <summary className="landing-faq__question">
                                {faq?.question}
                            </summary>

                            {/* Render the answer. */}
                            <div className="landing-faq__answer">
                                {faq?.answer}
                            </div>

                        </details>

                    ))}

                </div>

            </div>

        </section>

    );

};